import { ReactNode } from 'react';
import styled from 'styled-components';
import { useChipContext } from './chip.context';
import { theme } from './chip.theme';

interface ChipLabelProps {
	/**
	 * The text or number to display.
	 */
	children: ReactNode;
}

const StyledChipLabel = styled.span`
	--font: inherit;

	font: var(--font);
	color: inherit;
	min-width: 0;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;

	&[data-size='small'] {
		--font: ${theme.getValue('smallText')};
	}
	&[data-size='medium'] {
		--font: ${theme.getValue('mediumText')};
	}
`;

/* ########################################################################## */
/* ############################### PUBLIC API ############################### */
/* ########################################################################## */

/**
 * The textual content of a `Chip`. It automatically adapts its typography to
 * the `size` of the `Chip` and inherits the color from its `type`.
 */
export function ChipLabel({ children }: ChipLabelProps) {
	const { size } = useChipContext();

	return <StyledChipLabel data-size={size}>{children}</StyledChipLabel>;
}

export type { ChipLabelProps };
